import React from 'react';
import { LineChart, CartesianGrid, Legend, XAxis, YAxis, Line, Tooltip } from 'recharts';
import { formatMoney } from '../../../helpers';

const CustomLineChart = (props) => {
  const { data, stroke, width, height, dataKey = 'Total'} = props;  
  return (
    <LineChart
		width={width}
		height={height}
		data={data}
		margin={{ top: 5, right: 30, left: 20, bottom: 5}}
	>
		<CartesianGrid strokeDasharray="3 3" />
		<XAxis dataKey="name"/>
		<YAxis />
		<Legend />
		<Tooltip formatter={(value, name, props) => ( tooltipFormat(value, name, props) )}/>
		<Line type="monotone" dataKey={dataKey}stroke={stroke} />
	</LineChart>
  );

  function tooltipFormat (value, name, props) {
	if (name === 'Total')
		return formatMoney(value);
	return value;
  }

};

export default CustomLineChart;
